// Recent muscle load for the heat map. The formula is the bot's (digest.ts), which mirrors
// SQL muscle_load() and RecoverCore LoadModel: (intensity/5) * 0.5^(hours/48).
import { loadContribution, loadLevel, type LoadLevel } from '../../../supabase/functions/_shared/digest.ts';
import type { Session } from '../backend/types.ts';
import { groupOf } from './catalog.ts';

export { loadLevel, type LoadLevel };

export interface MuscleLoad { load: number; level: LoadLevel; lastWorkedAt: string; sessions: number }

export function muscleLoads(sessions: Session[], now = new Date(), days = 7): Map<string, MuscleLoad> {
  const start = now.getTime() - days * 86_400_000;
  const out = new Map<string, MuscleLoad>();
  for (const s of sessions) {
    const t = new Date(s.started_at).getTime();
    if (s.status !== 'logged' || s.intensity == null || t > now.getTime() || t <= start) continue;
    const c = loadContribution(s.intensity, (now.getTime() - t) / 3_600_000);
    for (const id of new Set(s.muscles.map((m) => m.muscle_id))) {
      const prev = out.get(id);
      const load = (prev?.load ?? 0) + c;
      out.set(id, {
        load, level: loadLevel(load), sessions: (prev?.sessions ?? 0) + 1,
        lastWorkedAt: prev && prev.lastWorkedAt > s.started_at ? prev.lastWorkedAt : s.started_at,
      });
    }
  }
  return out;
}

/** Group load = the highest load among its muscles. */
export function groupLoads(loads: Map<string, MuscleLoad>): Map<string, number> {
  const out = new Map<string, number>();
  for (const [id, l] of loads) {
    const g = groupOf(id);
    if (g) out.set(g, Math.max(out.get(g) ?? 0, l.load));
  }
  return out;
}
